import { render, staticRenderFns } from "./Work.vue?vue&type=template&id=6fe8f00d&scoped=true&"
var script = {}
import style0 from "./Work.vue?vue&type=style&index=0&id=6fe8f00d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe8f00d",
  null
  
)

export default component.exports